import React from 'react';

import { useGetLoyaltyDetails } from 'src/app/queries/loyalty/get-details';

import { QueryBuilderMultiSelect } from './shared/query-builder-multi-select';

type LoyaltyTierDropdownProps = {
  disabled?: boolean;
  onChange: (value: (number | string)[]) => void;
  values: string;
};

type LoyaltyTier = {
  id: number | string;
  name: string;
};

export function LoyaltyTierDropdown({ disabled, onChange, values }: LoyaltyTierDropdownProps) {
  const { data: loyaltyDetails } = useGetLoyaltyDetails();

  const transformedTiers: LoyaltyTier[] = (loyaltyDetails?.Tiers || []).map((tier) => ({
    id: tier.Name ?? '',
    name: tier.Name,
  }));

  return (
    <QueryBuilderMultiSelect<LoyaltyTier>
      automationIdPrefix='loyalty-tier'
      defaultLabel='Select a loyalty tier'
      disabled={disabled}
      idKey='id'
      items={transformedTiers}
      loading={false}
      nameKey='name'
      values={values}
      onChange={onChange}
    />
  );
}
